
import React, { useState } from 'react';

function Rulesets() {
  const [rules, setRules] = useState(['Focus on Olympic lifts', '']);

  const handleRuleChange = (idx, value) => {
    const updated = [...rules];
    updated[idx] = value;
    setRules(updated);
  };

  const addRule = () => setRules([...rules, '']);

  const removeRule = (idx) => {
    setRules(rules.filter((_, i) => i !== idx));
  };

  return (
    <div style={{ maxWidth: 600, margin: '2rem auto' }}>
      <h2>Workout Generation Rulesets</h2>
      <p>Define constraints you'd like to have on the plan:</p>
      {rules.map((rule, idx) => (
        <div key={idx} style={{ display: 'flex', marginBottom: 8 }}>
          <input
            type="text"
            value={rule}
            onChange={e => handleRuleChange(idx, e.target.value)}
            placeholder={`Constraint #${idx + 1}`}
            style={{ flex: 1, marginRight: 8 }}
          />
          <button onClick={() => removeRule(idx)} disabled={rules.length === 1}>Remove</button>
        </div>
      ))}
      <button onClick={addRule}>Add Constraint</button>
    </div>
  );
}

export default Rulesets;